import React from "react";
import { SocialIcon } from "react-social-icons";

export default function SocialFlow() {
  return (
    <div className="mt-3">
      <h3 className="mb-2 text-center ">للتواصل</h3>
      <div className="mt-3 flex gap-2 justify-center">
        <SocialIcon url="https://api.whatsapp.com/send?phone=201028876202" />
        <SocialIcon url="https://www.facebook.com/profile.php?id=100011192833917" />
        <SocialIcon url="https://www.instagram.com/mahmoudabdallah6158/" />
        <SocialIcon url="tel:+0201028876202" />
      </div>
    </div>
  );
}
